import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import './index.css';
import MainApp from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<MainApp />)

reportWebVitals();
